<template>
	<div>
		<b-form-checkbox id="checkbox-privacy" :class="vclass" :value="value" unchecked-value="0" name="privacy" v-if="showCheck">
			<div v-html="text"></div>
			<div class="invalid-feedback w-100" v-if="error">
				<strong v-html="error">{{ error }}</strong>
			</div>
		</b-form-checkbox>
		<div v-if="showCheck" class="privacy-small">
			<div v-html="smalltext"></div>
			<div v-if="lang === 'nl'">
				<a href="#" @click.prevent="HideBox()">Click hier</a> als je niet wilt dat RestoPass gebruikmaakt van jouw gegevens
			</div>
			<div v-else>
				Pour que mes données ne soient pas exploitées par RestoPass, <a href="#" @click.prevent="HideBox()">Cliquer ici</a>
			</div>
		</div>
		<div v-if="!showCheck">
			<div v-html="clicktext"></div>
			<input type="hidden" name="privacy" value="2" />
		</div>
	</div>
</template>

<script>

	export default {

		props: ['vclass', 'text', 'smalltext', 'clicktext', 'lang', 'error'],

		data() {
			return {
				value: 1,
				showCheck: true,
			}
		},

		methods: {
			HideBox() {
				this.showCheck = false
			}
		},

	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/Privacy.vue